import React from 'react';
import {
  InfoPopup,
  RequirementPopup,
  BrandConflictPopup,
  DisplayConflictPopup,
  SizeConflictPopup,
  LockedPopup,
  MobileBuildSummaryPopup
} from '../../AppPopups.js';
import EmailSalesForm from '../../EmailSalesForm.js';
import { MissingCompulsoryPopup } from './CompulsoryPopup.js';

const PopupManager = ({
  // Info popup
  showInfoPopup,
  infoPopupProduct,
  selectedSubCategory,
  categoryConfig,
  onCloseInfo,

  // Requirement popup
  showRequirementPopup,
  requirementData,
  onAddAllRequirements,
  onCloseRequirement,

  // Brand conflict popup
  showBrandConflictPopup,
  brandConflictData,
  selectedProducts,
  onNavigateToCategory,
  onSwitchEcosystem,
  onCloseBrandConflict,

  // Display conflict popup
  showDisplayConflictPopup,
  displayConflictData,
  onSwitchDisplayEcosystem,
  onCloseDisplayConflict,

  // Size conflict popup
  showSizeConflictPopup,
  sizeConflictData,
  onCloseSizeConflict,

  // Locked popup
  showLockedPopup,
  lockedMessage,
  onCloseLocked,

  // Mobile build summary popup
  showMobileBuildSummary,
  mainCategories,
  totalPrice,
  totalTestPrice,
  onCloseMobileBuildSummary,
  onRemoveProduct,
  onShareBuild,
  onContactSales,

  // Email sales form
  showEmailSalesForm,
  onCloseEmailSales,

  // NEW: Missing compulsory popup
  showMissingCompulsoryPopup,
  missingCompulsoryItems,
  onCloseMissingCompulsory
}) => (
  <>
    {showInfoPopup && infoPopupProduct && (
      <InfoPopup
        product={infoPopupProduct}
        selectedSubCategory={selectedSubCategory}
        categoryConfig={categoryConfig}
        onClose={onCloseInfo}
      />
    )}

    {showRequirementPopup && requirementData && (
      <RequirementPopup
        requirementData={requirementData}
        categoryConfig={categoryConfig}
        onAddAll={onAddAllRequirements}
        onClose={onCloseRequirement}
      />
    )}

    {showBrandConflictPopup && brandConflictData && (
      <BrandConflictPopup
        brandConflictData={brandConflictData}
        categoryConfig={categoryConfig}
        onNavigateToCategory={onNavigateToCategory}
        onSwitchEcosystem={onSwitchEcosystem}
        selectedProducts={selectedProducts}
        onClose={onCloseBrandConflict}
      />
    )}

    {showDisplayConflictPopup && displayConflictData && (
      <DisplayConflictPopup
        displayConflictData={displayConflictData}
        categoryConfig={categoryConfig}
        onClose={onCloseDisplayConflict}
        onNavigateToCategory={onNavigateToCategory}
        onSwitchDisplayEcosystem={onSwitchDisplayEcosystem}
        selectedProducts={selectedProducts}
      />
    )}

    {showSizeConflictPopup && sizeConflictData && (
      <SizeConflictPopup
        sizeConflictData={sizeConflictData}
        categoryConfig={categoryConfig}
        onClose={onCloseSizeConflict}
        onNavigateToCategory={onNavigateToCategory}
        selectedProducts={selectedProducts}
      />
    )}

    {showLockedPopup && (
      <LockedPopup
        message={lockedMessage}
        onClose={onCloseLocked}
      />
    )}

    {showMobileBuildSummary && (
      <MobileBuildSummaryPopup
        selectedProducts={selectedProducts}
        mainCategories={mainCategories}
        categoryConfig={categoryConfig}
        totalPrice={totalPrice}
        totalTestPrice={totalTestPrice}
        onClose={onCloseMobileBuildSummary}
        onNavigateToCategory={onNavigateToCategory}
        onRemoveProduct={onRemoveProduct}
        onShareBuild={onShareBuild}
        onContactSales={onContactSales}
      />
    )}

    {showEmailSalesForm && (
      <EmailSalesForm
        selectedProducts={selectedProducts}
        totalPrice={totalPrice}
        onClose={onCloseEmailSales}
      />
    )}

    {/* NEW: Missing compulsory items popup */}
    {showMissingCompulsoryPopup && missingCompulsoryItems && missingCompulsoryItems.length > 0 && (
      <MissingCompulsoryPopup
        missingItems={missingCompulsoryItems}
        onNavigateToCategory={onNavigateToCategory}
        onClose={onCloseMissingCompulsory}
      />
    )}
  </>
);

export default PopupManager;
